<script setup>
import { Overlay,LoadingDummyP,H1Title, } from '@/assets/js/src/components/all'
import { useTranslation,useHandleRoutableLink,usePrefetchData, } from '@/assets/js/src/util/composables'
import CookieConsent from '@/assets/js/src/modules/imprint/_components/CookieConsent.vue'
import { useHeadInfoTitle, } from '@/assets/js/src/layout/useHeadInfo'

let { messagesLoaded, } = usePrefetchData({
    loadAsyncMessages: [ 'imprint', 'common', ],
})

const { handleRoutableLink, } = useHandleRoutableLink()
const { t, } = useTranslation()
const { title, } = useHeadInfoTitle({ titleKey: 'async.imprint.title', })
</script>

<template>
    <overlay
        class-name="imprint"
    >
        <h1-title :messages-keys="['imprint']">
            {{ title }}
        </h1-title>

        <div
            v-if="messagesLoaded"
            class="imprint__content"
            @click="handleRoutableLink"
            v-html="t('async.imprint.text')"
        >
        </div>
        <template
            v-else
        >
            <loading-dummy-p
                count="4"
                height="18px"
                margin="8px 0"
                key-prefix="dummy_3"
            ></loading-dummy-p>
            <loading-dummy-p
                count="6"
                height="18px"
                margin="8px 0"
                key-prefix="dummy_4"
            ></loading-dummy-p>
        </template>
        <cookie-consent />
    </overlay>
</template>

<style lang="scss">
.bs-app .imprint {
    ul {
        margin-bottom: 16px;
    }
}
</style>
